import * as pages from "./document";

export default pages;
